function debounce(func: Function, milliseconds = 100) {
    let timer: number;

    return function (...args: any[]) {
        if (timer) clearTimeout(timer);

        timer = setTimeout(func, milliseconds, ...args);
    };
}

export { debounce };
